import { appstr } from "../utils/appstr";
import { QRadioButton } from "./QRadioButton";
import { Globals } from "./Globals";

export class QRadioButtonGroup {
  constructor() {
    this.fRadioButtons = null;
    this.fHorzSpacing = 100;
    this.fColSets = 2;
    this.fMaxWidth = null;
    this.fParentPanel = null;
    this.fHorzSet = false;
  }

  InitRadioButtonGroup(
    radioGroupDesc,
    xPos,
    yPos,
    parentPanel,
    defaultIndex,
    horzGroup,
    doLookup,
    isSet,
    cmdParamObj
  ) {
    this.fRadioButtons = [];

    this.fParentPanel = parentPanel;
    this.fUIColors = parentPanel.fUIColors;

    if (this.fUIColors == null) this.fUIColors = Globals._wsMgr.GetUIColors();
    if (isSet) this.fHorzSet = isSet;
    var textColor = this.fUIColors.GetHeaderTextColor();
    var n = radioGroupDesc.length;
    var xStart = xPos;
    for (var i = 0; i < n; i++) {
      var rB = new QRadioButton();
      rB.InitRadioButton(this);
      rB.SetMaxWidth(this.fMaxWidth);
      rB.PositionElement(xPos, yPos);
      rB.SetTextColor(textColor);
      rB.fIndex = i;

      rB.AddCmdParameter("option", radioGroupDesc[i][0]); // raw string option (not the label)
      if (cmdParamObj)
        rB.fAdditionalCmdParameters = Object.assign({}, rB.fAdditionalCmdParameters, cmdParamObj);
      if (doLookup) rB.SetLabel(appstr(radioGroupDesc[i][0]));
      else rB.SetLabel(radioGroupDesc[i][0]);

      var rowHeight = rB.AutoSize();

      if (horzGroup || this.fHorzSet) {
        if (horzGroup) xPos = xPos + this.fHorzSpacing;

        if (this.fHorzSet) {
          if ((i + 1) % this.fColSets != 0) xPos = xPos + this.fHorzSpacing;
          else {
            xPos = xStart;
            yPos = yPos + rowHeight;
          }
        }
      } else yPos = yPos + rowHeight;

      rB.SetCmdCode(radioGroupDesc[i][1]);
      parentPanel.PushElement(rB);
      this.fRadioButtons.push(rB);
    }

    if (defaultIndex != null) {
      var defaultRB = this.GetIndexRadioButton(defaultIndex);
      if (defaultRB != null) defaultRB.SetChecked(true);
      else {
        defaultRB = this.GetIndexRadioButton("0");
        defaultRB.SetChecked(true);
        console.log("Radio Button did not exist, defaulting to index 0");
      }
    }
  }

  RepositionGroup(x, y) {
    for (var idx in this.fRadioButtons) {
      var curButton = this.fRadioButtons[idx];
      if (x != null) curButton.SetPositionX(x);
      if (y != null) curButton.SetPositionY(y);
    }
  }

  SetTextColor(textColor) {
    for (var aButton in this.fRadioButtons) this.fRadioButtons[aButton].fTextColor = textColor;
  }

  SetMaxWidth(maxWidth) {
    this.fMaxWidth = maxWidth;
  }

  SetHorzSpacing(horzSpacing) {
    this.fHorzSpacing = horzSpacing;
  }

  GetNumButtons() {
    return this.fRadioButtons.length;
  }

  GetIndexRadioButton(index) {
    return this.fRadioButtons[index];
  }

  SelectRadioButtonByIndex(index) {
    var rB = this.GetIndexRadioButton(index);
    rB.SetChecked(true);
  }

  RadioButtonSelected(theButton) {
    var n = this.GetNumButtons();
    for (var i = 0; i < n; i++) {
      var rB = this.GetIndexRadioButton(i);
      var theState = false;
      if (rB == theButton) theState = true;

      rB.PSetChecked(theState);
    }
  }

  SelectedButton() {
    var n = this.GetNumButtons();
    for (var i = 0; i < n; i++) {
      var rB = this.GetIndexRadioButton(i);
      if (rB.IsChecked()) return rB;
    }

    return null;
  }

  SelectedButtonIndex() {
    var n = this.GetNumButtons();
    for (var i = 0; i < n; i++) {
      var rB = this.GetIndexRadioButton(i);
      if (rB.IsChecked()) return i;
    }

    return -1;
  }

  SetShownState(show) {
    var n = this.GetNumButtons();
    for (var i = 0; i < n; i++) {
      var rB = this.GetIndexRadioButton(i);
      rB.SetShownState(show);
    }
  }

  SetEnabled(enabled) {
    var n = this.GetNumButtons();
    for (var i = 0; i < n; i++) {
      var rB = this.GetIndexRadioButton(i);
      rB.SetEnabled(enabled);
    }
  }

  GetPositionY() {
    var firstButton = this.GetIndexRadioButton(0);
    var topY = firstButton.GetPositionY();

    return topY;
  }

  GetHeight() {
    var topY = this.GetPositionY();
    var lastButton = this.GetIndexRadioButton(this.GetNumButtons() - 1);
    var bottomY = lastButton.GetPositionY() + lastButton.GetHeight();

    return bottomY - topY;
  }

  GetWidth() {
    var width = 1;
    for (var aButtonIdx in this.fRadioButtons) {
      var theButton = this.GetIndexRadioButton(aButtonIdx);
      if (theButton.GetWidth() > width) width = theButton.GetWidth();
    }

    return width;
  }

  RemoveElements() {
    var n = this.fRadioButtons.length;
    for (var i = 0; i < n; i++) this.fParentPanel.RemoveElement(this.fRadioButtons[i]);
  }
}
